import { getInitials } from "./getInitials";

const Avatar = ({ img, fullName, className }) => {
  return (
    <>
      {img ? (
        <img
          src={img}
          alt={getInitials(fullName)}
          className={`rounded-full object-cover size-9 !mr-2 !border !border-[rgb(217,205,255)] ${className}`}
        />
      ) : (
        <div
          className={`rounded-full size-12 !mr-2 !text-[#7f56d9] !bg-[#f4f0ff] flex shrink-0 items-center justify-center font-medium ${className}`}
        >
          {getInitials(fullName)}
        </div>
      )}
    </>
  );
};

export default Avatar;
